// World feedback bursts — pure spec for the expanding ground ring the renderer pulses on big
// player moments (level-up, weapon evolve). Render-only: the renderer pools the meshes and
// animates 0→maxRadius while fading. No sim/determinism impact.

export interface BurstSpec {
  /** ring colour (hex) */
  color: number
  /** how far the ring expands (world units) */
  maxRadius: number
  /** seconds the ring lives */
  duration: number
}

const LEVELUP: BurstSpec = { color: 0x6cf0ff, maxRadius: 7, duration: 0.55 }
const EVOLVE: BurstSpec = { color: 0xffd23d, maxRadius: 11, duration: 0.8 }

/** Burst spec for a player event; defaults to the level-up ring. */
export function burstSpec(kind: string): BurstSpec {
  switch (kind) {
    case 'evolve':
      return EVOLVE
    case 'levelup':
      return LEVELUP
    default:
      return LEVELUP
  }
}

/** Ring radius + fade at age `t` (sec) given a spec — eased so it pops out then settles. */
export function burstAt(spec: BurstSpec, t: number): { radius: number; alpha: number } {
  const u = Math.max(0, Math.min(1, t / spec.duration))
  const ease = 1 - (1 - u) * (1 - u) // ease-out: fast start, gentle finish
  return { radius: ease * spec.maxRadius, alpha: (1 - u) * 0.7 }
}
